import React, { useRef, useState } from "react";
import {
  Box,
  Button,
  Text,
  useToast,
  VStack,
} from "@chakra-ui/react";
import { importComplianceCareGaps } from "../services/complianceService";

/**
 * Epic Care Gaps Exchange CSV import.
 * Expected headers: patient_id, measure_code, due_date, patient_name, status
 */
const ComplianceCareGapsImport = ({ onImported }) => {
  const toast = useToast();
  const inputRef = useRef(null);
  const [importing, setImporting] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setImporting(true);
    try {
      const result = await importComplianceCareGaps(file);
      toast({
        title: "Care gaps imported",
        description: `Created ${result.created}, updated ${result.updated} alerts.`,
        status: "success",
        duration: 5000,
        isClosable: true,
      });
      if (onImported) onImported(result);
    } catch (err) {
      toast({
        title: "Import failed",
        description: err.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setImporting(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <Box
      p={4}
      bg="gray.50"
      borderRadius="md"
      borderWidth="1px"
      borderColor="gray.200"
    >
      <Text fontWeight="semibold" mb={2}>
        Epic Care Gaps import
      </Text>
      <VStack align="stretch" spacing={2}>
        <input
          ref={inputRef}
          type="file"
          accept=".csv,text/csv"
          style={{ display: "none" }}
          onChange={handleFile}
        />
        <Button
          size="sm"
          colorScheme="purple"
          variant="outline"
          isLoading={importing}
          loadingText="Importing…"
          onClick={() => inputRef.current?.click()}
        >
          Upload Care Gaps CSV
        </Button>
        <Text fontSize="xs" color="gray.600" m={0}>
          CSV columns: patient_id, measure_code, due_date, patient_name, status
          (open | resolved). Aligns with Epic Care Gaps Exchange flat file.
        </Text>
      </VStack>
    </Box>
  );
};

export default ComplianceCareGapsImport;
